import { render, staticRenderFns } from "./PatientInfoDialog.vue?vue&type=template&id=6551d144&"
import script from "./PatientInfoDialog.vue?vue&type=script&lang=ts&"
export * from "./PatientInfoDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports